// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useEffect, useState, useContext } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

import MainLayout from '../../layouts/MainLayout';
import Timer from '../../components/Timer';
import LoadingIcon from '../../components/LoadingIcon';
import MultilineText from '../../components/MultilineText';
import MemberContext from '../../contexts/MemberContext';
import ExamSelector from '../../redux/selectors/ExamSelector';
import { CreditMethod, RunningLabSourceFrom } from '../../types/Model';
import { parseDuration, useQuery, getQueryParams } from '../../lib/utility';
import { useParamsId } from '../../lib/utility';

import QuestionnairePage from '../QuestionnairePage';
import Overview from './components/Overview';
import OverviewLabel from './components/ExamOverviewLabel'
import ExamMarkdown from './components/ExamMarkdown';
import ExamNavigation from './components/Navigation';
import ExamPopSubmit from './components/ExamPopSubmit';
import ExamScore from './components/ExamResult';

import { S } from './ExamPageStyle';

import {
  useFetchExamInformation,
  useBuyExam,
  useTestExam,
  useEndExam,
  // useFetchExamHistory,
  useRetakeQuestion,
  getUploadFileUrl
} from './hooks';
import { FormattedMessage } from 'react-intl';

const ExamPage = (): JSX.Element => {
  const history = useHistory();
  const creditMethod = CreditMethod.OrganizationCredit; // [TODO] selected by user
  const member = useContext(MemberContext);
  const id = useParamsId();
  const query = getQueryParams(useQuery()) as { workshopId?: string, condition?: string, courseId?: string, iltCourseId?: string};
  const { condition } = query;
  // exam info states
  const exam = useSelector(ExamSelector.makeExamByIdSelector(id));

  const isFetchingExam = useSelector(ExamSelector.makeIsFetchingExam());
  const examErrors = useSelector(ExamSelector.makeError());
  const [examStart, setExamStart] = useState(() => {
    if (member.runningExam && member.runningExam.id === id) {
      return true;
    } else {
      // 還沒 Start
      return false;
    }
  });

  const [examResult, setexamResult] = useState();

  // const [examHistory, setExamHistory] = useState([]);
  const [baseUrl, setBaesUrl] = useState('');
  const [examIsLoading, setExamIsLoading] = useState(true);
  //MultiSelect content
  const [examList, setExamList] = useState(
    () => {
      const cacheExamList = localStorage.getItem('examList');
      if (cacheExamList) {
        return JSON.parse(cacheExamList);
      } else {
        // 還沒 Start
        return [];
      }
    }
  );
  //QA content
  const [examQAList, setExamQAList] = useState(
    () => {
      const cacheQAExamList = localStorage.getItem('examQAList');
      if (cacheQAExamList) {
        return JSON.parse(cacheQAExamList);
      } else {
        // 還沒 Start
        return [];
      }
    }
  );

  // 目前 focus 的題目類型 multiSelect / qna
  const [examFocusType, setExamFocusType] = useState(() => {
    const focusType = localStorage.getItem('examFocusType');
    if (focusType) {
      return focusType;
    } else {
      const navigationStoreList = localStorage.getItem('examList');
      const navigationStoreQAList = localStorage.getItem('examQAList');
      if (navigationStoreList) {
        return 'multiSelect';
      } else if (navigationStoreQAList) {
        return 'qna';
      } else {
        return null;
      }
    }
  })

  // 目前 user 點選的 navigation button
  const [examNowFocus, setExamNowFocus] = useState(() => {
    const nowFocus = localStorage.getItem('examLastFocus');
    if (nowFocus) {
      return nowFocus;
    } else {
      return '0';
    }
  });

  // exam 要 render 的題目
  const [examClickToRender, setExamClickToRender] = useState(() => {
    const nowFocus = localStorage.getItem('examLastFocus');
    const navigationStoreList = localStorage.getItem('examList');
    const navigationStoreQAList = localStorage.getItem('examQAList');
    if (examFocusType === 'multiSelect' && navigationStoreList && nowFocus) {
      return JSON.parse(navigationStoreList)[parseInt(nowFocus)];
    } else if (examFocusType === 'qna' && navigationStoreQAList && nowFocus) {
      return JSON.parse(navigationStoreQAList)[parseInt(nowFocus)];
    } else {
      return ([]);
    }
  });

  const handleExamRender = (title: number) => {
    if (examFocusType === 'multiSelect') {
      setExamClickToRender(examList[title]);
    } else {
      setExamClickToRender(examQAList[title]);
    }
  };

  // 是否是最後一個 Topic (目前停留的標題 == examList 最後一個標題)
  const [isFinalQuestion, setFinalQuestion] = useState(() => {
    if (exam.runningInfo) {
      if (examFocusType === 'multiSelect' && examList.length !== 0 && examNowFocus === examList[examList.length - 1].title) {
        return true;
      } else if (examFocusType === 'qna' && examQAList.length !== 0 && examNowFocus === examQAList[examQAList.length - 1].title) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  });

  // Timer states
  const [endExamTime, setEndExamTime] = useState<Date>();

  const [showScore, setShowScore] = useState(false);
  const [topicAndRemark, setTopicAndRemark] = useState(false);
  const [clickSubmit, setClickSubmit] = useState(false);

  const courseId = query.courseId ? parseInt(query.courseId, 10) : undefined;
  // Workshop States
  const workshopId = query.workshopId ? parseInt(query.workshopId, 10) : undefined;
  const { endTime } = exam.relatedWorkshop || { endTime: new Date() };
  const iltCourseId = query.iltCourseId ? parseInt(query.iltCourseId, 10) : undefined;

  const fetchExam = useFetchExamInformation(id, { workshopId, iltCourseId });
  const refreshExam = useFetchExamInformation(id, { workshopId, iltCourseId, preventLoading: true });
  // for questionnaire
  const [showQuestionnaire, setShowQuestionnaire] = useState(false);
  const [examRecordId, setExamRecordId] = useState<number>();

  const examContentprocess = (examdata: any) => {
    const examContents = examdata.multiSelectContents;
    const QAContents = examdata.qnaContents;
    if (examContents) {
      examContents.forEach(function(item: any) {
        item.isComplete = false;
        item.isRemark = false;
        item.answers = [];
      });
      setExamList(examContents);
      setExamFocusType('multiSelect');
      setExamClickToRender(examContents[0]);
      if (examContents.length === 1) {
        setFinalQuestion(true);
      }
      localStorage.setItem('examList', JSON.stringify(examContents));
      localStorage.setItem('examFocusType', 'multiSelect');
    } else {
      // No MultiSelect part
      setExamClickToRender(QAContents[0]);
      setExamFocusType('qna');
      if (QAContents.length === 1) {
        setFinalQuestion(true);
      }
      localStorage.setItem('examFocusType', 'qna');
    }
    if (QAContents) {
      QAContents.forEach(function(item: any) {
        item.isComplete = false;
        item.isRemark = false;
        item.answers = '';
        item.file = '';
      });
      setExamQAList(QAContents);
      localStorage.setItem('examQAList', JSON.stringify(QAContents));
    }
    setExamNowFocus('0');
    localStorage.setItem('examLastFocus', '0');
  }

  const retakeQuestion = async () => {
    try {
      const result = await useRetakeQuestion(id);
      examContentprocess(result);
    } catch (e) {
      setExamStart(false);
    }
    setExamIsLoading(false);
  }

  useEffect(() => {
    fetchExam();
    if (member.runningExam && member.runningExam.id === id) {
      setExamStart(true);
    } else {
      // 還沒 Start
      setExamStart(false);
    }
  }, [id, workshopId, iltCourseId]);

  useEffect(() => {
    member.update();
    if (exam.runningInfo) {
      setBaesUrl(exam.runningInfo.markdownUrl)
    }
  }, [exam.runningInfo]);

  useEffect(() => {
    const reTake = async () => {
      await retakeQuestion();
    }
    if (exam.multiSelectCount || exam.qnaCount) {
      const cacheExam = localStorage.getItem('examList');
      const cacheExamQA = localStorage.getItem('examQAList');
      setExamIsLoading(true);
      if ((examStart && parseInt(exam.multiSelectCount) > 0 && !cacheExam) || (examStart && parseInt(exam.qnaCount) > 0 && !cacheExamQA)) {
        reTake();
      } else {
        setExamIsLoading(false);
      }
    }
  }, [exam.multiSelectCount, exam.qnaCount])

  useEffect(() => {
    if (examFocusType === 'multiSelect' && examList.length != 0 && examNowFocus == examList[examList.length - 1].title) {
      setFinalQuestion(true);
    } else if (examFocusType === 'qna' && examQAList.length != 0 && examNowFocus == examQAList[examQAList.length - 1].title) {
      setFinalQuestion(true);
    } else {
      setFinalQuestion(false);
    }
  }, [examClickToRender]);

  useEffect(() => {
    if (member.runningExam) {
      setExamRecordId(member.runningExam.recordId);
    }
  }, [member.runningExam]);

  const handleBuyExam = async () => {
    setExamIsLoading(true);
    try {
      const examContentResult = await useBuyExam(id, {creditMethod, workshopId, courseId, iltCourseId});
      refreshExam();
      examContentprocess(examContentResult);
      setExamStart(true);
      setExamIsLoading(false);
    } catch (error) {
      setExamStart(false);
      setExamIsLoading(false);
    }
  };

  const handleTestExam = async () => {
    setExamIsLoading(true);
    try {
      const examContentResult = await useTestExam(id);
      refreshExam();
      examContentprocess(examContentResult);
      setExamStart(true);
      setExamIsLoading(false);
    } catch (error) {
      setExamStart(false);
      setExamIsLoading(false);
      console.log(error)
    }
  };

  const endExam = async () => {
    setExamStart(false);
    setExamIsLoading(true);
    if (condition !== 'Test') {
      setShowQuestionnaire(true);
    }
    const answerList: { title: any; answers: any; }[] = [];
    examList.forEach(function(item: any) {
      return answerList.push({
        title: item.title,
        answers: item.answers
      });
    });
    const answerQAList: { title: any; answers: any; fileName: any}[] = [];
    const fileList: any = {};
    examQAList.forEach(function(item: any) {
      if (item.base64Data && item.fileName) {
        const name = item.fileName;
        fileList[name] = item.base64Data;
      }
      return answerQAList.push({
        title: item.title,
        answers: item.answers,
        fileName: item.fileName
      });
    });
    try {
      if (exam.runningInfo) {
        if (Object.keys(fileList).length !== 0) {
          await getUploadFileUrl(id, exam.runningInfo.examRecordId, fileList);
        }
        const examResult = await useEndExam(id, exam.runningInfo.examRecordId, answerList, answerQAList);
        const score = examResult.score;
        if (score != undefined) {
          setexamResult(examResult);
          setShowScore(true);
          resetAllState();
        } else {
          setExamStart(true);
          setExamIsLoading(false);
        }
      }
    } catch (error) {
      console.log(error)
    }
  };

  const resetAllState = () => {
    refreshExam();
    setExamIsLoading(false);
    setExamNowFocus('0');
    setExamStart(false);
    setExamQAList([]);
    localStorage.removeItem('examList');
    localStorage.removeItem('examQAList');
    localStorage.removeItem('examLastFocus');
    localStorage.removeItem('examFocusType');
  };

  const hanleCloseResult = () => {
    setShowScore(false);
    history.push('/home');
  };

  const handleTimeUp = () => {
    endExam();
  };

  const handleExamRemark = (title: string) => {
    if (examFocusType === 'multiSelect') {
      const nowRemark = examList[parseInt(title)].isRemark;
      if (nowRemark === false) {
        examList[parseInt(title)].isRemark = true;
      } else {
        examList[parseInt(title)].isRemark = false;
      }
      localStorage.setItem('examList', JSON.stringify(examList));
    } else {
      const nowRemark = examQAList[parseInt(title)].isRemark;
      if (nowRemark === false) {
        examQAList[parseInt(title)].isRemark = true;
      } else {
        examQAList[parseInt(title)].isRemark = false;
      }
      localStorage.setItem('examQAList', JSON.stringify(examQAList));
    }
    setTopicAndRemark(current => !current);
  };

  const handleChoosedAnswer = (title: string, answer: string) => {

    const currentAnswer = examList[parseInt(title)].answers;
    const multiAnswer = examList[parseInt(title)].multiAnswer;
    if (multiAnswer) {
      if (currentAnswer.indexOf(answer) > -1) {
        examList[parseInt(title)].answers.splice(currentAnswer.indexOf(answer), 1);
      } else {
        examList[parseInt(title)].answers.push(answer);
      }
    } else {
      examList[parseInt(title)].answers = [answer];
    }

    examList[parseInt(title)].isComplete = true;
    if (examList[parseInt(title)].answers.length === 0) {
      examList[parseInt(title)].isComplete = false;
    }

    localStorage.setItem('examList', JSON.stringify(examList));
    setExamClickToRender(examList[title]);
    setTopicAndRemark(current => !current);
  };

  const handleQnaAnswer = (title: string, answer: string) => {
    const cacheList = localStorage.getItem('examQAList');
    examQAList[parseInt(title)].answers = answer;
    examQAList[parseInt(title)].isComplete = true;
    if (cacheList) {
      const tmpList = JSON.parse(cacheList);
      tmpList[parseInt(title)].answers = answer;
      tmpList[parseInt(title)].isComplete = true;
      // 不讓 file 的 data 進到 localstorage
      localStorage.setItem('examQAList', JSON.stringify(tmpList));
    }

    setExamClickToRender(examQAList[title]);
    setTopicAndRemark(current => !current);
  }

  const handleFileUpload = (title: string, file: File, base64Data: any) => {
    const cacheList = localStorage.getItem('examQAList');
    examQAList[parseInt(title)].isComplete = true;
    if (cacheList) {
      const tmpList = JSON.parse(cacheList);
      tmpList[parseInt(title)].isComplete = true;
      // 不讓 file 的 data 進到 localstorage
      localStorage.setItem('examQAList', JSON.stringify(tmpList));
    }

    // file 不存在 localStorage 因為有5M的限制
    examQAList[parseInt(title)].fileName = file.name;
    examQAList[parseInt(title)].file = file;
    if (base64Data !== '') {
      examQAList[parseInt(title)].base64Data = base64Data;
    }
    setExamClickToRender(examQAList[title]);
    setTopicAndRemark(current => !current);
  }

  if (showQuestionnaire) {
    const basicInfo: any = {
      memberId: member.id,
      sourceId: workshopId ? workshopId : courseId ? courseId : iltCourseId ? iltCourseId : null,
      sourceFrom: workshopId ? 'workshop' : courseId ? 'onlineCourse' : iltCourseId ? 'iltCourse' : 'own',
      handsOnType: 'exam',
      handsOnId: id,
      handsOnRecordId: examRecordId,
    }
    return (
      <MainLayout>
        <S.PopMask>
          <S.QuestionnaireContainer>
            <QuestionnairePage basicInfo={basicInfo} setShowQuestionnaire={setShowQuestionnaire}/>
          </S.QuestionnaireContainer>
        </S.PopMask>
      </MainLayout>
    )
  }

  if (isFetchingExam) {
    return (
      <MainLayout>
        <S.LoadingContainer>
          <LoadingIcon size={20} />
        </S.LoadingContainer>
      </MainLayout>
    );
  }

  if (examErrors) {
    return (
      <MainLayout>
        <S.ChallengeErrorContainer>
          <S.ChallengeErrorForbiddenImage alt="challenge-error" />
          <S.ErrorText><FormattedMessage id="K005" /></S.ErrorText>
          {/* <S.ErrorText>{JSON.stringify(examErrors)}</S.ErrorText> */}
          <S.ErrorButton as={Link} to={'/exams'} ><FormattedMessage id="E016" /></S.ErrorButton>
        </S.ChallengeErrorContainer>
      </MainLayout>
    );
  }

  const renderLoading = () => {
    return (
      <S.LoadingContainer>
        <LoadingIcon size={20} />
      </S.LoadingContainer>
    )
  }

  const renderRunning = (): JSX.Element | undefined => {
    if (exam.runningInfo) { // This exam is running
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{
              <Timer
                startedTime={new Date(exam.runningInfo.startTime)}
                endLabTime={endExamTime}
                duration={exam.duration}
                onTimesUp={handleTimeUp}
              />}
            </S.TimerDurationText>
            <S.StartButton onClick={() => { setClickSubmit(true) }}><FormattedMessage id="K003" /></S.StartButton>
          </S.StartStopContainer>
          { examList.length > 0 ? (
            <>
              <S.ExamNavigationTitle>Multi Select</S.ExamNavigationTitle>
              <ExamNavigation
                examList={examList}
                examNowFocus={examNowFocus}
                examFocusType={examFocusType}
                navigationType={'multiSelect'}
                setExamNowFocus={setExamNowFocus}
                setExamFocusType={setExamFocusType}
                setExamClickToRender={setExamClickToRender}
                topicAndRemark={topicAndRemark}
              />
            </>
          ) : null}
          { examQAList.length > 0 ? (
            <>
              <S.ExamNavigationTitle>Q & A</S.ExamNavigationTitle>
              <ExamNavigation
                examList={examQAList}
                examNowFocus={examNowFocus}
                examFocusType={examFocusType}
                navigationType={'qna'}
                setExamNowFocus={setExamNowFocus}
                setExamFocusType={setExamFocusType}
                setExamClickToRender={setExamClickToRender}
                topicAndRemark={topicAndRemark}
              />
            </>
          ) : null}
        </>
      )
    }

    if (!member.isLoading && member.runningExam) { // Other exam is running
      const query = member.runningExam.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningExam.sourceId}` :
        member.runningExam.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningExam.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningExam.sourceId}` : '';
      const url = `/exams/${member.runningExam.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="K015" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="K014" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="K016" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningChallenge) { // Other challenge is running
      const query = member.runningChallenge.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningChallenge.sourceId}` :
        member.runningChallenge.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningChallenge.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningChallenge.sourceId}` : '';
      const url = `/challenges/${member.runningChallenge.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E041" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }

    if (!member.isLoading && member.runningLab) { // Other lab is running
      const query = member.runningLab.sourceFrom === RunningLabSourceFrom.Workshop ? `?workshopId=${member.runningLab.sourceId}` :
        member.runningLab.sourceFrom === RunningLabSourceFrom.Test ? '?condition=Test' :
          member.runningLab.sourceFrom === RunningLabSourceFrom.Ilt ? `?iltCourseId=${member.runningLab.sourceId}` : '';
      const url = `/labs/${member.runningLab.id}${query}`;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={true}><FormattedMessage id="E040" /></S.StartButton>
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.DescriptionText><FormattedMessage id="E009" values={{ br: <br /> }} /></S.DescriptionText>
            <S.LinkButton as={Link} to={url}><FormattedMessage id="E010" /></S.LinkButton>
          </S.DescriptionContainer>
        </>
      )
    }
  }

  const renderCreditBuyCondition = () => {
    if (exam.costCredit) {
      const memberCredit = (creditMethod === CreditMethod.OrganizationCredit ? member.organizationCredit : member.organizationCredit) || 0;
      const isEnough = exam.costCredit <= memberCredit;
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton disabled={!isEnough}><FormattedMessage id="K001" /></S.StartButton>
            {isEnough && (
              <S.ConfirmStartContainer>
                <S.ConfirmStartTitle><FormattedMessage id="E003" values={{ credit: exam.costCredit }} /></S.ConfirmStartTitle>
                <S.StartButton onClick={handleBuyExam}><FormattedMessage id="K001" /></S.StartButton>
              </S.ConfirmStartContainer>
            )}
          </S.StartStopContainer>
          <S.DescriptionContainer>
            <S.CreditAmount>
              <FormattedMessage id="E005" values={{ credit: exam.costCredit, creditEl: <S.Credit>{exam.costCredit}</S.Credit> }} />
              <S.CreditNotion />
            </S.CreditAmount>
            <S.DescriptionText>
              {<FormattedMessage id={isEnough ? 'E006' : 'E007'} values={{ credit: memberCredit, creditEl: <S.DescriptionCreditText>{memberCredit}</S.DescriptionCreditText> }} />}
            </S.DescriptionText>
            {
              !isEnough && (
                <S.DescriptionText>
                  {member.organizationId ? (
                    <FormattedMessage id="E008" values={{ br: <br />, managerEmail: <S.DescriptionEmailText href={`mailto:${exam.organizationContactEmail}`}>{exam.organizationContactEmail}</S.DescriptionEmailText> }} />
                  ) : (
                    null
                    // <>請購買 Credit 以繼續</> /**未來有做B2C的話要補這塊 */
                  )}
                </S.DescriptionText>
              )
            }
          </S.DescriptionContainer>
          {/* { examHistory.length === 0 ? null : <ExamRecord examHistory={examHistory}></ExamRecord>} */}
        </>
      )
    }
  }

  const renderBuying = (): JSX.Element | null => {
    if (exam.runningInfo || examStart) {
      return null;
    }
    if (condition === 'Test' && member.isManager) {
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton onClick={handleTestExam}>測試考試</S.StartButton>
          </S.StartStopContainer>
          {/* { examHistory.length === 0 ? null : <ExamRecord examHistory={examHistory}></ExamRecord>} */}
        </>
      )
    }

    if (workshopId || iltCourseId) {
      return (
        <>
          <S.StartStopContainer>
            <S.TimerDurationText>{parseDuration(exam.duration).all}</S.TimerDurationText>
            <S.StartButton onClick={handleBuyExam}><FormattedMessage id="K001" /></S.StartButton>
          </S.StartStopContainer>
          {/* { examHistory.length === 0 ? null : <ExamRecord examHistory={examHistory}></ExamRecord>} */}
        </>
      )
    }
    return (
      <>
        {renderCreditBuyCondition()}
      </>
    );
  }

  const renderMainContent = (): JSX.Element => {
    return (
      <S.Container inWorkshop={workshopId !== undefined} examStart={examStart}>
        <S.WrapperContent examStart={examStart}>
          {
            !examStart ? (
              <>
                {workshopId && <S.WorkshopLabel endTime={endTime} />}
                <S.ExamName>{exam.name}</S.ExamName>
                {/* <S.ECVLogoContainer><S.ECVLogoImage /></S.ECVLogoContainer> */}
                <OverviewLabel duration={exam.duration} participantNumber={exam.visitor} level={exam.level} multiSelectCount={exam.multiSelectCount} qnaCount={exam.qnaCount} passingScore={exam.passingScore}></OverviewLabel>
                <Overview><MultilineText text={exam.overview} /></Overview>
              </>
            ) : (
              exam.runningInfo ? (
                <>
                  <S.CollapseTransition visible={true}>
                    <ExamMarkdown
                      topicContents={examClickToRender}
                      examNowFocus={examNowFocus}
                      examFocusType={examFocusType}
                      setExamNowFocus={setExamNowFocus}
                      handleExamRemark={handleExamRemark}
                      handleExamRender={handleExamRender}
                      handleChoosedAnswer={handleChoosedAnswer}
                      handleQnaAnswer={handleQnaAnswer}
                      handleFileUpload={handleFileUpload}
                      isFinalQuestion={isFinalQuestion}
                      baseUrl={exam.runningInfo.markdownUrl}
                    />
                  </S.CollapseTransition>
                </>
              ) : renderLoading()
            )
          }
        </S.WrapperContent>
        <S.WrapperSidebar inWorkshop={workshopId !== undefined} examStart={examStart}>
          { member.runningExam || member.runningLab || member.runningChallenge ? renderRunning() : renderBuying()}
        </S.WrapperSidebar>
        { clickSubmit ? <ExamPopSubmit examList={examList} examQAList={examQAList} setClickSubmit={setClickSubmit} endExam={endExam}></ExamPopSubmit> : null }
      </S.Container>
    )
  }

  const renderScore = (): JSX.Element => {
    return (
      <ExamScore baseUrl={baseUrl} hanleCloseResult={hanleCloseResult} examResult={examResult} examList={examList}></ExamScore>
    )
  }

  return (
    <S.MainLayout examStart={examStart}>
      { examIsLoading? renderLoading() : showScore ? renderScore() : renderMainContent() }
    </S.MainLayout>
  );
}

export default ExamPage;
